import axios from "axios";
import axiosConfig from "./axiosConfig";
import requestErrorHandler from "./requestErrorHandler";

/**
 * Base fetcher function for SWR using axios
 */
export const fetcher = async (url: string) => {
  try {
    const response = await axiosConfig.get(url);
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const message = error.response?.data?.message || error.message;
      throw new Error(`API error: ${message}`);
    }
    throw error;
  }
};

/**
 * API base URL
 */
export const API_BASE_URL = "https://staging-axiosConfig.godump.co/api/v2";

/**
 * API endpoints
 */
export const API_ENDPOINTS = {
  FLEET: {
    ALL: "newAdmin/fleet-owners/all",
    APPROVE: `/newAdmin/approve-fleet-account`,
    DISABLE: (id: string) => `/fleet/disable/${id}`,
  },
  RENTER: {
    RENTERS: "/renter/admin/individual-renters",
    BUSINESS_RENTERS: "/renter/admin/business-renters",
    PARTNERS: "/newPartner/get-all",
    APPROVE: `/newAdmin/approve-fleet-account`,
    DISABLE: (id: string) => `/fleet/disable/${id}`,
  },
  ADMIN: {
    ALL: "",
    EDIT:"/newAdmin/edit-admin",
    DISABLE:(id:string) =>`/newAdmin/delete-admin?id=${id}`,
    SET_PASSWORD: "/newAdmin/admin-set-password"
  },
  TRUCK_CATEGORY:{
    ALL:"/newAdmin/truck-category-all",
    GET_ONE:(id:string)=> `/newAdmin/one-truck-category?id=${id}`,
    CREATE:"/newAdmin/create-truck-category",
    UPDATE:"/newAdmin/truck-category-update",
    DELETE:"/newAdmin/truck-category-delete"
  },
  ZONES:{
    ALL:"/zone/all",
    CREATE:"/zone/create",
  },
  ZONE_MAPPING:{
    MAP_ZONES: "/zone/map-zone",
    GET_MAPPED_ZONES: (id:string)=> `/zone/mapped-zone/category?vehicleCategoryId=${id}`,
    UPDATE:"/zone/update-mapped-zone",
    DELETE:(id:string)=> `/zone/delete-mapped-zone?zoneId=${id}`
  },
  REFERRAL: {
    AGENTS: "/referral/referral-agents",
    COMMISSION_RATE: "/referral/commission-rate",
    COMMISSION_CAP: "/referral/commission-rate/caps",
  }
  // Add other API endpoints as needed
};

/**
 * Fleet API functions
 */
export const fleetAPI = {
  getAll: () =>
    axiosConfig.get(API_ENDPOINTS.FLEET.ALL).then((res) => res.data),

  action: async (id: string, type: FleetOwner["approved"]) => {
    try {
      const response = await axiosConfig.post(API_ENDPOINTS.FLEET.APPROVE, {
        fleetOwnerId: id,
        status: type,
      });
      return response.data;
    } catch (error) {
      requestErrorHandler(error);
      throw error;
    }
  },
};
